export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q01_a.bb0a8df8.png";